export class SegmentRelation {
	Id: number;
	SegmentId: number;
	ServiceTypeId: number;
	CreatedOn: Date;
	CreatedByUserId: number;
	ModifiedOn: Date;
	ModifiedByUserId: number;
	ReviewedOn: Date;
	ReviewedByUserId: number;
	Active: boolean;
}
